<template>
    <div>
        <table-tool-bar>
            <template slot="left"></template>
            <Button v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd">
                新增资讯
            </Button>
        </table-tool-bar>
        <Table ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="showInfo(row)">详情</Button>
                <PoptipButton v-if="$can('delete')"
                    :disabled="loading"
                    text="删除" transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => { rowConfirmDelete(row) }">
                </PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch">
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal v-model="modal.showInformation"
            :title="curId ? '资讯编辑' : '资讯登记'"
            :width="800"
            :height="560"
            :maskClosable="false"
            :buttons.sync="formBtns"
            @close-by-confirm="search">
            <form-information v-if="modal.showInformation" :id="curId">
            </form-information>
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import FormInformation from './form-information'
import { informationList, informationDelete } from '@/api/information-manage'
import Dict from '_u/dict'

const PAGE_SIZE = 20

export default {
    name: 'ListInformation',

    components: {
        FormInformation
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE
            },
            page: {
                total: 0,
                list: []
            },
            dict: {
                notifyType: Dict.NULL
            },
            modal: {
                showInformation: false
            },
            curId: '',
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'title',
                    title: '资讯标题',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'notifyType',
                    title: '资讯类别',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.notifyType.val())
                },
                {
                    key: 'createTime',
                    title: '发布时间',
                    align: 'left',
                    width: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'publisher',
                    title: '发布人',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed:"right",
                    slot: 'action'
                }
            ]
        }
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                    Dict.get(['notify_type']),
                    informationList(this.filter)
                ])
                .then(args => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ""
            this.modal.showInformation = true
        },

        showInfo(row) {
            this.curId = row.id
            this.modal.showInformation = true
        },

        rowConfirmDelete(row) {
            this.loading = true

            informationDelete(row.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .then(() => this.fetch())
                .finally(() => this.loading = false)
        }
    }
}
</script>
<style lang="less"
    scoped>
</style>